var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information-icon",
    d: "M66,56A10,10,0,1,0,76,66,10,10,0,0,0,66,56Zm0,4.1a1.3,1.3,0,1,1-1.3,1.3A1.3,1.3,0,0,1,66,60.1Zm2.4,11.3H64a.8.8,0,0,1,0-1.6h1.4V65.4h-.8a.8.8,0,0,1,0-1.6h1.6a.8.8,0,0,1,.8.8v5.2h1.4a.8.8,0,1,1,0,1.6Z",
    transform: "translate(-56 -56)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.527838b39ed5a9209faa1083b3153944.svg";
export { ForwardRef as ReactComponent };